import React from "react"
import { SocialIcon } from "./style"

export const IconFacebook = () => (
  <SocialIcon
    href="https://www.facebook.com/LukasGabrielProductions/"
    rel="noopener"
    target="_blank"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="48px"
      height="48px"
      viewBox="0 0 32 32"
    >
      <path
        fill="#FFFFFF"
        d="M16.5,32c0.828,0,1.5-0.672,1.5-1.5V16h3.848c0.726,0,1.348-0.52,1.476-1.235l0.359-2 c0.078-0.437-0.041-0.887-0.326-1.227S22.651,11,22.207,11H18V8.083c0-1.647,0.826-2.597,3.1-2.597h1.4c0.828,0,1.5-0.672,1.5-1.5 V1.593c0-0.789-0.611-1.443-1.397-1.497C21.836,0.044,20.845,0,19.774,0C15.592,0,12,2.651,12,7.519V11H9.5 C8.672,11,8,11.672,8,12.5v2C8,15.328,8.672,16,9.5,16H12v14.5c0,0.828,0.672,1.5,1.5,1.5H16.5z"
      />
    </svg>
  </SocialIcon>
)

export const IconYoutube = () => (
  <SocialIcon
    href="https://www.youtube.com/user/fabrykasportu/featured"
    rel="noopener"
    target="_blank"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="48px"
      height="48px"
      viewBox="0 0 32 32"
    >
      <path
        fill="#FFFFFF"
        d="M25.056,6.2C22.405,6.1,19.002,6,16,6c-2.992,0-6.381,0.099-9.028,0.199 c-2.599,0.098-4.686,2.161-4.806,4.76C2.078,12.844,2,14.854,2,16c0,0.917,0.084,3.012,0.175,5.012 c0.118,2.6,2.217,4.672,4.818,4.764C10.029,25.883,13.835,26,16,26c2.312,0,6.068-0.116,9.048-0.222 c2.604-0.093,4.696-2.159,4.815-4.761C29.938,19.388,30,17.571,30,16c0-1.578-0.062-3.405-0.138-5.039 C29.743,8.366,27.651,6.298,25.056,6.2z M13.927,19.915c-0.155,0.079-0.34,0.072-0.488-0.019S13.2,19.643,13.2,19.469v-6.939 c0-0.174,0.09-0.336,0.239-0.426c0.148-0.091,0.333-0.098,0.488-0.019l6.8,3.469C20.894,15.64,21,15.812,21,16 c0,0.188-0.105,0.36-0.273,0.445L13.927,19.915z"
      />
    </svg>
  </SocialIcon>
)

export const IconInstagram = () => (
  <SocialIcon
    href="https://www.instagram.com/lukasgabriel_productions/"
    rel="noopener"
    target="_blank"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="48px"
      height="48px"
      viewBox="0 0 32 32"
    >
      <path
        fill="#FFFFFF"
        d="M26,0H6C2.686,0,0,2.686,0,6v6v14c0,3.314,2.686,6,6,6h20c3.314,0,6-2.686,6-6V12V6C32,2.686,29.314,0,26,0z  M24,5c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2c0,0.552-0.448,1-1,1h-2c-0.552,0-1-0.448-1-1V5z M20,16c0,2.206-1.794,4-4,4 s-4-1.794-4-4s1.794-4,4-4S20,13.794,20,16z M28,26c0,1.103-0.897,2-2,2H6c-1.103,0-2-0.897-2-2V12h5.11C8.422,13.181,8,14.535,8,16 c0,4.418,3.582,8,8,8c4.418,0,8-3.582,8-8c0-1.465-0.422-2.819-1.109-4H28V26z"
      />
    </svg>
  </SocialIcon>
)
